import { JSX } from "react";
import ContentLayout from "@amzn/awsui-components-react/polaris/content-layout";
import Header from "@amzn/awsui-components-react/polaris/header";
import Grid, { GridProps } from "@amzn/awsui-components-react/polaris/grid";

/**
 * Props for the CustomGridLayout component
 *
 * @interface
 * @property {string} title - Represent the title of the page being rendered
 * @property {JSX.Element} leftSection - The right section of the layout
 * @property {JSX.Element} rightSection - The left section of the layout
 */
export interface CustomGridLayoutProps {
    title: string;
    actions?: React.ReactNode;
    counter?: React.ReactNode;
    leftSection: JSX.Element;
    rightSection: JSX.Element;
    gridDefinition: ReadonlyArray<GridProps.ElementDefinition>;
}

/**
 * A content layout used to customize two section in a horizontal grid
 *
 * @param {string} title - The title of the content layout
 * @param {JSX.Element} leftSection - The right section of the layout
 * @param {JSX.Element} rightSection - The left section of the layout
 * @param {ReadonlyArray<GridProps.ElementDefinition>} gridDefinition - An array of element definitions
 * that specifies how the columns must be arranged
 * @returns {JSX.Element} - The rendered content layout
 */
export default function CustomGridLayout({
    title,
    actions,
    counter,
    leftSection: filterSection,
    rightSection: contentSection,
    gridDefinition,
}: CustomGridLayoutProps): JSX.Element {
    return (
        <ContentLayout
            header={
                <Header variant="h1" actions={actions} counter={counter}>
                    {title}
                </Header>
            }
        >
            <Grid gridDefinition={gridDefinition}>
                {filterSection}
                {contentSection}
            </Grid>
        </ContentLayout>
    );
}
